import { LoadablePaint } from '@confluence/loadable';

export const LazyApplicationNavigatorPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApplicationNavigatorContainer" */ '../src/ApplicationNavigator/ApplicationNavigatorPage'
			)
		).ApplicationNavigatorPage,
});
